import React from 'react'
import Drawer from '@material-ui/core/Drawer'
import 'twin.macro'

const inputFiels = {
  title: { name: 'title', valueField: 'value' },
  description: { name: 'description', valueField: 'value' },
  isPrivate: { name: 'private', valueField: 'checked' },
}

export default function AddTopic({
  defaultOpen = false,
  onSubmit = async () => {},
  t = (key, options = {}) => options.defaultValue || key,
}) {
  const [isOpen, toggleOpen] = React.useState(defaultOpen)
  async function handleSubmit(event) {
    event.preventDefault()
    const form = event.target
    const inputs = Object.values(inputFiels).reduce(
      (result, { name, valueField }) => ({
        ...result,
        [name]: form.elements[name][valueField],
      }),
      {},
    )
    onSubmit(inputs).finally(() => {
      toggleOpen(false)
    })
  }

  const [charCount, setCharCount] = React.useState(0)

  return (
    <div
      tw="flex flex-row items-center w-full cursor-pointer"
      style={{ padding: '10px 15px' }}
      onClick={() => toggleOpen(true)}
    >
      <span
        className="icon-container"
        tw="mr-4 w-12 h-12 border-solid border-2 rounded-sm border-gray-100 text-gray-100 flex justify-center items-center"
      >
        <svg width={24} height={24} viewBox="0 0 18 18" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 17a1 1 0 102 0v-7h7a1 1 0 100-2h-7V1a1 1 0 00-2 0v7H1a1 1 0 100 2h7v7z"
            fill="currentColor"
          />
        </svg>
      </span>
      <span className="">{t('label', { defaultValue: '建立新收藏清單' })}</span>
      <Drawer anchor="bottom" open={isOpen} style={{ zIndex: 2000 }}>
        <form onSubmit={handleSubmit} tw="h-screen bg-gray-30 flex flex-col">
          <header tw="relative bg-white h-12 flex justify-center items-center flex-shrink-0">
            <button
              onClick={(event) => {
                event.preventDefault()
                event.stopPropagation()
                toggleOpen(false)
              }}
              tw="absolute left-0 p-4 text-black bg-transparent rounded-sm border-0"
            >
              <svg width={16} height={16} viewBox="0 0 16 16" tw="block">
                <path
                  d="M1 1l14 14m0-14L1 15"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                />
              </svg>
              <span tw="sr-only">{t('drawer.closeLabel', { defaultValue: '關閉' })}</span>
            </button>
            <span tw="text-black font-bold">
              {t('drawer.title', { defaultValue: '建立收藏清單' })}
            </span>
          </header>
          <div tw="px-4 mt-6 space-y-4 flex-grow">
            <div tw="p-4 flex flex-col bg-white text-black space-y-4">
              <label htmlFor="topic-title">
                {t('drawer.inputTitle', { defaultValue: '名稱' })}
              </label>
              <input
                id="topic-title"
                name={inputFiels.title.name}
                placeholder={t('drawer.inputTitlePlaceholder', {
                  defaultValue: '請輸入妳的收藏清單名稱',
                })}
                tw="border-none text-b1 placeholder-gray-100"
                required
              />
            </div>
            <div tw="p-4 flex flex-col bg-white text-black space-y-4">
              <label htmlFor="topic-description">
                {t('drawer.inputDescription', { defaultValue: '敘述' })}
              </label>
              <textarea
                id="topic-description"
                name={inputFiels.description.name}
                placeholder={t('drawer.inputDescriptionPlaceholder', {
                  defaultValue: '介紹一下妳的收藏清單吧',
                })}
                rows={5}
                maxLength={20}
                onChange={(e) => setCharCount(e.target.value.length)}
                tw="border-none text-b1 placeholder-gray-100"
                style={{ fontFamily: 'inherit' }}
              />
              <span tw="text-right text-gray-100">{charCount}/20</span>
            </div>
            <div tw="p-4 bg-white text-black flex items-center">
              <input
                type="checkbox"
                id="topic-is-private"
                name={inputFiels.isPrivate.name}
                tw="m-0 mr-2"
              />
              <label htmlFor="topic-is-private" tw="w-full">
                {t('drawer.inputPrivate', { defaultValue: '將收藏清單設為隱私' })}
              </label>
            </div>
          </div>
          <footer tw="px-4 flex-shrink-0 mb-6">
            <button
              type="submit"
              disabled={false}
              tw="h-8 w-full bg-primary-indigo disabled:bg-gray-200 text-white bg-primary-indigo rounded-sm border-0 p-0"
            >
              {t('drawer.submitLabel', { defaultValue: '建立' })}
            </button>
          </footer>
        </form>
      </Drawer>
    </div>
  )
}
